export default __webpack_public_path__ + "static/media/Header_logo1.5514b8b3.png";